import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center', // Align icon and text vertically centered
    width: 'fit-content',
    margin: '5px 5px',
    background: theme.palette.background.default,
    padding: 6,
    borderRadius: 6,
    border: `1px solid ${theme.palette.grey[300]}`
  },
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    marginRight: 6,
    '& svg': {
      fontSize: 20
    }
  },
  text: {
    lineHeight: 1,
    [theme.breakpoints.down('sm')]: {
      fontSize: 10
    }
  }
}))
export default useStyles
